/* @flow */
import { PropTypes } from 'react';

export const PendingRoleShape = PropTypes.shape({
  role: PropTypes.string.isRequired,
  is_affirmed: PropTypes.bool,
  is_opted_in: PropTypes.bool,
  is_email_confirmed: PropTypes.bool.isRequired,
  official_email: PropTypes.string,
});

// AffiliationShape
export default PropTypes.shape({
  organization_id: PropTypes.number.isRequired,
  roles: PropTypes.arrayOf(PropTypes.string).isRequired,
  pending_roles: PropTypes.arrayOf(PendingRoleShape).isRequired,
  is_member: PropTypes.bool.isRequired,
  can_have_role_changed: PropTypes.bool,
});

type PendingRole = {
  role: string,
  is_affirmed?: bool,
  is_opted_in?: ?bool,
  is_email_confirmed: bool,
  official_email?: string,
}

type Affiliation = {
  organization_id: number,
  roles: string[],
  pending_roles: PendingRole[],
  is_member?: bool,
  can_have_role_changed?: bool,
}

export const hasPendingRole = (affiliation: Affiliation) => {
  return !!affiliation.pending_roles.length;
};

export const isPendingAdmin = (affiliation: Affiliation) => {
  return !!affiliation.pending_roles.find(pr => pr.role === 'admin');
};

export const isAdmin = (affiliation: Affiliation) => {
  return affiliation.roles.includes('admin');
};

export const isTeacherOrAdmin = (affiliation: Affiliation) => {
  return affiliation.roles.includes('teacher') || affiliation.roles.includes('admin');
};

export const needsOptIn = (affiliation: Affiliation) => {
  const roleNeedsOptIn = role => !role.is_opted_in;
  return !!affiliation.pending_roles.find(roleNeedsOptIn);
};

const roleNeedsEmailConf = role => !role.is_email_confirmed;

export const needsEmailConf = (affiliation: Affiliation) => {
  return !!affiliation.pending_roles.find(roleNeedsEmailConf);
};

export const getNeedsEmailConf = (affiliation: Affiliation) => {
  return affiliation.pending_roles.find(roleNeedsEmailConf);
};

export const isMember = (aff: Affiliation) => !!aff.is_member;

export const removeRole = (aff: Affiliation, role: string) => {
  return {
    ...aff,
    roles: aff.roles.filter(r => r !== role),
  };
};



// WEBPACK FOOTER //
// ./src/shapes/Affiliation.js